/**
 * @file 试卷公式渲染
 * @description 把题干 HTML 里的 `math-node` 转成 KaTeX，供打印预览直接插入。
 *
 * @whenToUse 试卷模板渲染题干、选项、答案、讲解。
 * @whenNotToUse 后台普通文案（不含公式节点）。
 */

import katex from 'katex'
import 'katex/dist/katex.min.css'

/**
 * 将富文本中的公式节点渲染为 KaTeX HTML。
 * @param rawHtml 原始 HTML
 * @returns 可插入页面的 HTML
 */
export function renderMathHtml(rawHtml: string): string {
  if (!rawHtml) return ''
  const doc = new DOMParser().parseFromString(rawHtml, 'text/html')
  const mathNodes = doc.querySelectorAll('span[data-type="math"], span.math-node')

  mathNodes.forEach((node) => {
    const latex = node.getAttribute('data-latex') || ''
    node.innerHTML = katex.renderToString(latex, {
      throwOnError: false,
      output: 'html',
    })
    node.classList.add('math-inline')
  })

  return doc.body.innerHTML
}
